@let lectureSeule = !peutModifier();
@if (isLoading()) {
  <div class="bg-transparency absolute z-10 flex h-full w-full items-center justify-center opacity-70" role="status">
    <div class="flex items-center">
      <hlm-spinner class="text-white" icon="lucideLoaderCircle" hlmTooltipTrigger="Duplication en cours" size="xl" />
    </div>
  </div>
}

@if (profondeurActuelle() === '01' && !estCanvasElementsSupprimes()) {
  <f-flow
    [cdkContextMenuTriggerFor]="nodeContextMenu"
    [cdkContextMenuTriggerData]="{ data: null, type: 'canvas' }"
    [vCellSize]="CELL_SIZE"
    [hCellSize]="CELL_SIZE"
    (fSelectionChange)="onSelectionChange($event)"
    (fDragStarted)="dragCommence($event)"
    (fDragEnded)="deplacementElementFini()"
    (fLoaded)="onLoaded()"
    (fCreateConnection)="onConnectionDropped($event)"
    (contextmenu)="onCanvasContextMenu($event)"
    fDraggable
  >
    <f-selection-area />
    <f-background>
      <f-rect-pattern [vSize]="CELL_SIZE" [hSize]="CELL_SIZE"></f-rect-pattern>
    </f-background>
    <f-canvas fZoom>
      <f-connection-for-create />
      @for (jalon of jalons(); track jalon.id) {
        <div
          class="m-sm"
          [fGroupPosition]="{
            x: jalon.metadonnees.x,
            y: jalon.metadonnees.y,
          }"
          [fGroupSize]="{
            width: jalon.metadonnees.width,
            height: jalon.metadonnees.height,
          }"
          [fGroupId]="jalon.id"
          [cdkContextMenuTriggerFor]="nodeContextMenu"
          [cdkContextMenuTriggerData]="{ data: jalon, type: 'jalon' }"
          (onDoubleClick)="onDoubleClick(jalon.id)"
          fGroup
          fDragHandle
          appClickDouble
          hlmTooltipTrigger="Palier"
        >
          <div
            class="paragraph-small-medium text-components-content-neutral-primary border-grey-6 h-xl flex rounded-xs border bg-white p-[3px]"
          >
            {{ jalon.nom }}
          </div>
          <div class="jalon text-milestone h-full w-1/2 items-center">
            <ng-icon name="lucideFlag" />
          </div>
        </div>
      }

      <ng-container ngProjectAs="[fNodes]">
        @for (groupeEtapes of groupesEtapesALaCarte(); track groupeEtapes.id) {
          <app-groupe-etapes-a-la-carte
            [groupeEtapes]="groupeEtapes"
            [peutModifier]="peutModifier()"
            (showDetails)="navigateWithPathParameters(true)"
            (centrerEtapeALaCarte)="centrerEtapeALaCarte($event)"
            (supprimerGroupe)="supprimerGroupe(groupeEtapes.id)"
            (onDoubleClick)="onDoubleClick(groupeEtapes.id)"
            appClickDouble
          />
        }
      </ng-container>

      @for (etape of etapes(); track etape.id) {
        <div
          class="m-0 p-0"
          [class]="{
            etape: etape.estOuverte && isCodeEtapeValid(etape.codeEtape),
            'etape-fermee': !etape.estOuverte,
            'etape-erreur': !isCodeEtapeValid(etape.codeEtape) && etape.estOuverte,
            'etape-validee': etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE && etape.estOuverte,
            'etape-demande-validation': etape.etatValidation === ETAT_VALIDATION_ETAPE.A_VALIDER,
          }"
          [fNodeId]="etape.id"
          [fInputId]="'input--' + etape.id"
          [fNodeSize]="TAILLE_NOEUD_DEFAULT"
          [fNodePosition]="{
            x: etape.metadonnees.x,
            y: etape.metadonnees.y,
          }"
          [fNodeDraggingDisabled]="lectureSeule"
          [fInputDisabled]="lectureSeule"
          [cdkContextMenuTriggerFor]="nodeContextMenu"
          [cdkContextMenuTriggerData]="{ data: etape, type: 'étape' }"
          (onDoubleClick)="onDoubleClick(etape.id)"
          appClickDouble
          fNode
          fNodeInput
          fDragHandle
          fInputConnectableSide="left"
          hlmTooltipTrigger="Étape"
        >
          <div
            class="left"
            [fOutputId]="'output--' + etape.id + '--l'"
            [fOutputMultiple]="true"
            [fOutputDisabled]="lectureSeule"
            fNodeOutput
            fOutputConnectableSide="left"
          ></div>

          <div class="text-components-content-neutral-primary flex flex-col">
            <div
              class="border-stroke-neutral-light p-xs flex justify-between border-b"
              [class]="{
                'bg-feedback-negative-lightest': !isCodeEtapeValid(etape.codeEtape),
                'bg-feedback-positive-lightest':
                  etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE && etape.estOuverte,
                'bg-feedback-informative-lightest': etape.etatValidation === ETAT_VALIDATION_ETAPE.A_VALIDER,
              }"
            >
              <div class="flex">
                <span
                  class="mt-xxs mr-xxs"
                  [class]="{
                    'text-step':
                      etape.estOuverte &&
                      isCodeEtapeValid(etape.codeEtape) &&
                      etape.etatValidation === ETAT_VALIDATION_ETAPE.EN_COURS,
                    'text-components-content-neutral-quaternary': !etape.estOuverte,
                    'text-feedback-positive-main':
                      etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE && etape.estOuverte,
                    'text-feedback-negative-darker': !isCodeEtapeValid(etape.codeEtape) && etape.estOuverte,
                    'text-feedback-informative-main': etape.etatValidation === ETAT_VALIDATION_ETAPE.A_VALIDER,
                  }"
                  ><ng-icon name="lucideGrid2x2" hlm size="sm" />
                </span>
                <span
                  class="paragraph-component-small-medium uppercase"
                  [class]="{ 'text-components-content-neutral-quaternary': !etape.estOuverte }"
                  >{{ etape.nom }}</span
                >
              </div>

              @if (!isCodeEtapeValid(etape.codeEtape)) {
                <div
                  class="text-feedback-negative-main p-xxs"
                  hlmTooltipTrigger="Le code étape n'est pas au bon format"
                >
                  <ng-icon name="lucideCircleAlert" hlm size="sm" />
                </div>
              }

              @if (etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE) {
                <span
                  class="p-xxs"
                  [class]="{
                    'text-feedback-positive-main': etape.estOuverte,
                    'text-components-content-neutral-quaternary': !etape.estOuverte,
                  }"
                >
                  <ng-icon name="lucideCircleCheck" hlm size="sm" />
                </span>
              }
            </div>
            <div class="py-xs px-sm gap-xs flex flex-col">
              @if (etape.etatValidation === ETAT_VALIDATION_ETAPE.A_VALIDER) {
                <app-chip label="Étape à valider" variant="informative" icon="lucideCircleCheck" />
              } @else if ((etape.estCreeeManuellement || etape.estModifiee) && !etape.estExportee) {
                <app-chip label="Étape modifiée" variant="warning" icon="lucideCircleAlert" />
              } @else if (etape.estExportee) {
                <app-chip label="Étape exportée" variant="informative" icon="lucideCircleCheck" />
              }

              <span
                class="paragraph-small-medium"
                [class]="{ hidden: !etape.codeEtape, 'text-components-content-neutral-quaternary': !etape.estOuverte }"
              >
                <span [class]="{ 'text-content-tertiary': etape.estOuverte }">Code étape :</span>
                {{ etape.codeEtape }}</span
              >
              <span
                class="paragraph-small-medium"
                [class]="{ hidden: !etape.duree, 'text-components-content-neutral-quaternary': !etape.estOuverte }"
                ><span [class]="{ 'text-content-tertiary': etape.estOuverte }">Durée :</span>
                {{ etape.sommeMois }} mois</span
              >
            </div>
            <div
              class="py-xs px-sm text-content-tertiary border-stroke-neutral-light paragraph-small-medium flex flex-col content-center justify-between border-t"
              [class]="{
                'text-content-tertiary': etape.estOuverte,
                'text-components-content-neutral-quaternary': !etape.estOuverte,
              }"
            >
              <span>Certifiante : {{ etape.estCertifiante ? 'Oui' : 'Non' }}</span>
            </div>
          </div>

          <div
            class="right"
            [fOutputId]="'output--' + etape.id + '--r'"
            [fOutputMultiple]="true"
            [fOutputDisabled]="lectureSeule"
            fNodeOutput
            fOutputConnectableSide="right"
          ></div>
        </div>
      }

      @for (pointDeDepart of pointsDeDepart(); track pointDeDepart.id) {
        <div
          class="point-depart text-entry-point"
          [fInputId]="'input--' + pointDeDepart.id"
          [fNodePosition]="{
            x: pointDeDepart.metadonnees.x,
            y: pointDeDepart.metadonnees.y,
          }"
          [fNodeSize]="{
            height: TAILLE_NOEUD_DEFAULT.height / 2,
            width: TAILLE_NOEUD_DEFAULT.width,
          }"
          [fNodeId]="pointDeDepart.id"
          [fInputDisabled]="lectureSeule"
          [fNodeDraggingDisabled]="lectureSeule"
          [cdkContextMenuTriggerFor]="nodeContextMenu"
          [cdkContextMenuTriggerData]="{ data: pointDeDepart, type: 'étape' }"
          fNode
          fNodeInput
          fDragHandle
          fInputConnectableSide="right"
          hlmTooltipTrigger="Point de départ"
        >
          <ng-icon name="lucideTicketCheck" aria-hidden="false" aria-label="Point de départ" />
          <span class="text-small-medium text-components-content-neutral-primary">{{ pointDeDepart.nom }}</span>
          <div
            class="right"
            [fOutputId]="'output--' + pointDeDepart.id + '--r'"
            [fOutputMultiple]="true"
            [fOutputDisabled]="lectureSeule"
            fNodeOutput
            fOutputConnectableSide="right"
          ></div>
        </div>
      }

      @for (finParcours of finsParcours(); track finParcours.id) {
        <div
          class="fin-parcours text-endpoint"
          [fInputId]="'input--' + finParcours.id"
          [fInputMultiple]="true"
          [fNodePosition]="{
            x: finParcours.metadonnees!.x,
            y: finParcours.metadonnees!.y,
          }"
          [fNodeSize]="TAILLE_NOEUD_DEFAULT"
          [fNodeId]="finParcours.id"
          [fInputDisabled]="lectureSeule"
          [cdkContextMenuTriggerFor]="nodeContextMenu"
          [cdkContextMenuTriggerData]="{ data: finParcours, type: 'fin-parcours' }"
          (onDoubleClick)="onDoubleClick(finParcours.id)"
          appClickDouble
          fInputConnectableSide="left"
          fNode
          fNodeInput
          fDragHandle
          hlmTooltipTrigger="Fin de parcours"
        >
          <div
            class="left"
            [fOutputId]="'output--' + finParcours.id + '--l'"
            [fOutputMultiple]="true"
            [fOutputDisabled]="lectureSeule"
            fNodeOutput
            fOutputConnectableSide="left"
          ></div>
          <ng-icon name="lucideContactRound" aria-label="Fin de parcours" />
          <span class="paragraph-small-medium text-primary">{{ finParcours.nom }}</span>
        </div>
      }

      @for (connecteur of connecteurs(); track $index) {
        <f-connection
          [fReassignDisabled]="true"
          [fOutputId]="
            'output--' + (connecteur.idEtapePrecedente ?? connecteur.idGroupeEtapesALaCartePrecedent) + '--r'
          "
          [fInputId]="'input--' + (connecteur.idEtapeSuivante ?? connecteur.idGroupeEtapesALaCarteSuivant)"
          [fConnectionId]="
            (connecteur.idEtapePrecedente ?? connecteur.idGroupeEtapesALaCartePrecedent) +
            '-' +
            (connecteur.idEtapeSuivante ?? connecteur.idGroupeEtapesALaCarteSuivant)
          "
          [fSelectionDisabled]="lectureSeule"
          [cdkContextMenuTriggerFor]="nodeContextMenu"
          [cdkContextMenuTriggerData]="{ data: null, type: 'connecteur' }"
          fType="bezier"
          fBehavior="fixed"
        />
      }
    </f-canvas>
  </f-flow>
} @else if (estCanvasElementsSupprimes()) {
  <f-flow
    [cdkContextMenuTriggerFor]="nodeContextMenu"
    [cdkContextMenuTriggerData]="{ data: null, type: 'canvas' }"
    [vCellSize]="CELL_SIZE"
    [hCellSize]="CELL_SIZE"
    (fSelectionChange)="onSelectionChange($event)"
    (fDragStarted)="dragCommence($event)"
    (fDragEnded)="deplacementElementFini()"
    (fLoaded)="onLoaded()"
    (fCreateConnection)="onConnectionDropped($event)"
    (contextmenu)="onCanvasContextMenu($event)"
    fDraggable
  >
    <f-selection-area />
    <f-background>
      <f-rect-pattern [vSize]="CELL_SIZE" [hSize]="CELL_SIZE"></f-rect-pattern>
    </f-background>
    <f-canvas fZoom>
      <f-connection-for-create />
      @for (etape of etapesSupprimees(); track etape.id; let index = $index) {
        <div
          class="m-0 p-0"
          [class]="{
            etape: etape.estOuverte && isCodeEtapeValid(etape.codeEtape),
            'etape-fermee': !etape.estOuverte,
            'etape-erreur': !isCodeEtapeValid(etape.codeEtape) && etape.estOuverte,
            'etape-validee': etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE && etape.estOuverte,
            'etape-demande-validation': etape.etatValidation === ETAT_VALIDATION_ETAPE.A_VALIDER,
          }"
          [fNodeId]="etape.id"
          [fInputId]="'input--' + etape.id"
          [fNodeSize]="TAILLE_NOEUD_DEFAULT"
          [fNodePosition]="{
            x: TAILLE_NOEUD_DEFAULT.width * index * 1.5,
            y: 0,
          }"
          [cdkContextMenuTriggerFor]="nodeContextMenu"
          [cdkContextMenuTriggerData]="{ data: etape, type: 'étape' }"
          fNodeDraggingDisabled="true"
          fInputDisabled="true"
          fNode
          fNodeInput
          fDragHandle
          fInputConnectableSide="left"
          hlmTooltipTrigger="Étape"
        >
          <div class="text-components-content-neutral-primary flex flex-col">
            <div
              class="border-stroke-neutral-light p-xs flex justify-between border-b"
              [class]="{
                'bg-feedback-negative-lightest': !isCodeEtapeValid(etape.codeEtape),
                'bg-feedback-positive-lightest':
                  etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE && etape.estOuverte,
                'bg-feedback-informative-lightest': etape.etatValidation === ETAT_VALIDATION_ETAPE.A_VALIDER,
              }"
            >
              <div class="flex">
                <span
                  class="mt-xxs mr-xxs"
                  [class]="{
                    'text-step':
                      etape.estOuverte &&
                      isCodeEtapeValid(etape.codeEtape) &&
                      etape.etatValidation !== ETAT_VALIDATION_ETAPE.VALIDEE,
                    'text-components-content-neutral-quaternary': !etape.estOuverte,
                    'text-feedback-positive-main':
                      etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE && etape.estOuverte,
                    'text-feedback-negative-darker': !isCodeEtapeValid(etape.codeEtape) && etape.estOuverte,
                  }"
                  ><ng-icon name="lucideGrid2x2" hlm size="sm" />
                </span>
                <span
                  class="paragraph-component-small-medium uppercase"
                  [class]="{ 'text-components-content-neutral-quaternary': !etape.estOuverte }"
                  >{{ etape.nom }}</span
                >
              </div>

              @if (!isCodeEtapeValid(etape.codeEtape)) {
                <div
                  class="text-feedback-negative-main p-xxs"
                  hlmTooltipTrigger="Le code étape n'est pas au bon format"
                >
                  <ng-icon name="lucideCircleAlert" hlm size="sm" />
                </div>
              }

              @if (etape.etatValidation === ETAT_VALIDATION_ETAPE.VALIDEE) {
                <span
                  class="p-xxs"
                  [class]="{
                    'text-feedback-positive-main': etape.estOuverte,
                    'text-components-content-neutral-quaternary': !etape.estOuverte,
                  }"
                >
                  <ng-icon name="lucideCircleCheck" hlm size="sm" />
                </span>
              }
            </div>
            <div class="py-xs px-sm gap-xs flex flex-col">
              <app-chip label="Étape supprimée" variant="warning" icon="lucideCircleAlert" />

              <span
                class="paragraph-small-medium"
                [class]="{ hidden: !etape.codeEtape, 'text-components-content-neutral-quaternary': !etape.estOuverte }"
              >
                <span [class]="{ 'text-content-tertiary': etape.estOuverte }">Code étape :</span>
                {{ etape.codeEtape }}</span
              >
              <span
                class="paragraph-small-medium"
                [class]="{ hidden: !etape.duree, 'text-components-content-neutral-quaternary': !etape.estOuverte }"
                ><span [class]="{ 'text-content-tertiary': etape.estOuverte }">Durée :</span>
                {{ etape.sommeMois }} mois</span
              >
            </div>
            <div
              class="py-xs px-sm text-content-tertiary border-stroke-neutral-light paragraph-small-medium flex flex-col content-center justify-between border-t"
              [class.border-t]="!!etape.duree || !!etape.codeEtape"
              [class]="{
                'text-content-tertiary': etape.estOuverte,
                'text-components-content-neutral-quaternary': !etape.estOuverte,
              }"
            >
              <span>Cursus international : {{ etape.aCursusInternational ? 'Oui' : 'Non' }}</span>
              <span>Changement de ville : {{ etape.aChangementVille ? 'Oui' : 'Non' }}</span>
              <span>Certifiante : {{ etape.estCertifiante ? 'Oui' : 'Non' }}</span>
            </div>
          </div>
        </div>
      }
    </f-canvas>
  </f-flow>
} @else if (profondeurActuelle() === '02') {
  <app-canvas-renderer
    [id]="idElementSelectionne()"
    [type]="typeElementSelectionne()"
    [groups]="canvasEtape()"
    [groupTemplate]="etapeTemplate"
    [groupeConnecteurs]="connecteurs()"
    [modulesMapByEtapeId]="modulesMapByEtapeId()"
    [referentiel]="referentiel()"
    [cartographie]="cartographie()"
    [roles]="roles()"
    (onGroupSelection)="handleGroupeSelection($event)"
    (onNodeSelection)="handleNodeSelection($event)"
    (onModuleOrderChange)="handleModuleOrderChange($event)"
    (onModuleDelete)="supprimerModule($event)"
  >
  </app-canvas-renderer>

  <ng-template #etapeTemplate let-etape>
    <div class="etape h-full">
      <div class="header">
        <ng-icon name="lucideGrid2x2" />
        <p class="paragraph-small-medium">{{ etape.nom }}</p>
      </div>
    </div>
  </ng-template>
}

@if (peutModifier()) {
  <app-barre-d-outil
    [typeElementSelectionne]="typeElementSelectionne()"
    [cartographie]="cartographie()"
    [referentiel]="referentiel()"
    [parcours]="parcours()"
    [estCanvasElementsSupprimes]="estCanvasElementsSupprimes()"
    (onCreateNode)="handleCreateNode($event)"
    (onCreateFinParcours)="handleCreateFinParcours($event)"
    (onOpenDetails)="ouvreDetails()"
    (onToggleValidationParcours)="toggleValidationParcours()"
    (onToggleCanvasElementSupprimes)="toggleCanvasElementSupprimes()"
  />
}

<ng-template #nodeContextMenu let-data="data" let-type="type">
  <app-context-menu [menuItems]="nodeContextMenuItems(data, type)" [data]="data" />
</ng-template>
